<template>
  <div ref="growthMarkerDom">
    <div @click.stop="showContent" style="display: flex;align-items: center;justify-content: center;background: rgba(255, 255, 255, 0.2);width: 15px;height: 15px;border-radius: 50%">
      <div style="width: 9px;height: 9px;background: white;border-radius: 50%;"></div>
    </div>
    <div v-if="showContentIndex === item.index" style="position: absolute;top: 24px;height: 26px;border-radius: 13px;background: rgba(0,0,0,0.5);color: white;font-size: 12px;padding-left: 11px;padding-right: 11px;display: flex;align-items: center;white-space: nowrap;">
      {{ item.properties.content }}
    </div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";

export default {
  name: 'GrowthMarker',
  props: {
    item: {
      required: true,
    },
    map: {
      required: true,
    },
    showContentIndex: {
      required: true,
    },
  },
  data() {
    return {
      marker: '',
    }
  },
  methods: {
    addToMap() {
      this.marker = new mapboxgl.Marker(this.$refs.growthMarkerDom)
          .setLngLat([this.item.geometry.coordinates[0], this.item.geometry.coordinates[1]])
          .addTo(this.map)
    },
    showContent() {
      this.$emit('showContent', this.item)
    }
  },
  mounted() {
    this.addToMap()
  },
  beforeDestroy() {
    this.marker.remove()
  }
}
</script>

<style scoped>

</style>